/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
    BedToJSONTyped,
} from './Bed';

/**
 * 
 * @export
 * @interface FindAllBeds200Response
 */
export interface FindAllBeds200Response {
    /**
     * List of beds
     */
    data?: Array<Bed>;
}

/**
 * Check if a given object implements the FindAllBeds200Response interface.
 */
export function instanceOfFindAllBeds200Response(value: object): value is FindAllBeds200Response {
    return true;
}

export function FindAllBeds200ResponseFromJSON(json: any): FindAllBeds200Response {
    return FindAllBeds200ResponseFromJSONTyped(json, false);
}

export function FindAllBeds200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllBeds200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BedFromJSON)),
    };
}

export function FindAllBeds200ResponseToJSON(json: any): FindAllBeds200Response {
    return FindAllBeds200ResponseToJSONTyped(json, false);
}

export function FindAllBeds200ResponseToJSONTyped(value?: FindAllBeds200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BedToJSON)),
    };
}

